import { Condition } from 'types/GlobalKpiOption'

export const onlyLeftCondition = (condition: Condition | null) =>
  condition && [Condition.IS_NULL, Condition.IS_NOT_NULL].includes(condition)

export const validFilter = (
  condition: Condition | null,
  value: string | (string | number | null)[] | null
) => onlyLeftCondition(condition) || (condition && value)
